<template>
  <div class="pixel-second-step">
    <snow-checkboxes-dropdown
      v-model="innerValue"
      masculine
      label="Quais eventos você deseja receber?"
      :options="options"
      @input="value => $emit('update', value)"
    />

    <advanced-settings :form="form" :errors="errors" class="mt-6" />
  </div>
</template>
<script>
import AdvancedSettings from "./AdvancedSettings.vue";
export default {
  components: { AdvancedSettings },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      innerValue: ["track_initiate_checkout", "track_purchase"].filter(
        opt => this.form[opt]
      ),
      options: [
        {
          id: "track_initiate_checkout",
          label: "Visitas no checkout"
        },
        {
          id: "track_purchase",
          label: "Conversão de vendas"
        }
      ]
    };
  }
};
</script>
